import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ConfirmPopup from "../../../components/ConfirmPopup";
import { DialogPopup } from "../../../components/DialogPopup";
import AlertInfoIcon from "../../../images/icons/AlertInfoIcon.svg";
import EditIcon from "../../../images/icons/EditIcon.svg";
import TrashIcon from "../../../images/icons/TrashIcon.svg";
import { loadingPostDatedPresDetails } from "../../../Redux/Slice/PostDatedPresDetailsSlice";
import {
  AlertWarn,
  BtnGroupStyle,
  BtnIconStyle,
  DataGridListStyle,
} from "../../../Theme";
import { YSButton } from "../../../uikit/YSButton";
import { v4 as uuid } from "uuid";
import { RemovePostDatedPrescriptionById } from "../../../Apis/AuthApiServices";
import YSSnackBar from "../../../uikit/YSSnackBar";
import NoRecords from "../../../components/NoRecords";
import {
  DrugTextNTooltip,
  TextNTooltip,
  TextOnly,
} from "../../../components/Content";
import ErrorOverlay from "../../../components/ErrorOverlay";
import { loadingTopRibbon } from "../../../Redux/Slice/TopRibbonSlice";
import { Tooltip } from "@mui/material";

export default function PostDatedPresDetails(props: any) {
  const { setShowFlow } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const PostDatedPresDetailsState = useSelector((state: any) => {
    return { ...state.PostDatedPresDetailsSlice };
  }); //redux data
  const [selectionData, setSelectionData] = useState("");
  const [ErrorPopup, setErrorPopup] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [deleteDataPopup, setDeleteDataPopup] = useState(false);
  const [rowData, setRowData] = useState({});
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [rowCountState, setRowCountState] = useState(
    PostDatedPresDetailsState?.Pagination?.totalItems || 0
  );
  const columns2: GridColDef[] = [
    {
      field: "name",
      headerName: "Patient",
      width: 150,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: ({ row }) => {
        return (
          <Typography component="div" variant="body2">
            {row.patientFirstName} {row.patientLastName}
          </Typography>
        );
      },
    },
    {
      field: "description",
      headerName: "Drug",
      width: 180,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }) => <DrugTextNTooltip row={row} />,
    },
    {
      field: "pharmacyName",
      headerName: "Pharmacy",
      width: 180,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }) => <TextNTooltip Text={row.pharmacyName} />,
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 100,
      cellClassName: "w12",
      headerClassName: "w12",
      renderCell: (params: any) => <TextOnly Text={params.value} />,
    },
    {
      field: "postDatedPrescriptionDate",
      headerName: "Release Date",
      width: 100,
      cellClassName: "w12",
      headerClassName: "w12",
      renderCell: (params: any) => <TextOnly Text={params.value} />,
    },

    {
      field: "actions",
      headerName: "Actions",
      width: 60,
      cellClassName: "w8",
      headerClassName: "w8",
      renderCell: ({ row }) => (
        <>
          <Tooltip title="Edit">
            <IconButton
              type="button"
              onClick={() => {
                sessionStorage.setItem("patientId", row?.personId);
                navigate("/newrxpad", {
                  state: {
                    rowData: row,
                    key: "postDated",
                  },
                });
              }}
            >
              <img src={EditIcon} alt="Edit" loading="lazy" />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 80,
      cellClassName: "w10",
      headerClassName: "w10",
      renderCell: (params: any) => (
        <>
          {params.row.statusCode !== "900" ? (
            <YSButton
              className=""
              children={"TBS"}
              size={"small"}
              color="warning"
              variant="contained"
            />
          ) : (
            <YSButton
              onClick={() => {
                handleShowErrorPopupClick();
                setRowData(params.row);
              }}
              className="error2"
              children={"FAILED"}
              size={"small"}
              color="error"
              variant="contained"
            />
          )}
        </>
      ),
    },
  ];
  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("postDatedPrescriptionId", selectionData);
      const result = await RemovePostDatedPrescriptionById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        PostDatedPrescriptionsDetails(page);
        dispatch(loadingTopRibbon());
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const handleShowDeletePopupClick = () => {
    setDeleteDataPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeleteDataPopup(false);
  };
  const handleShowErrorPopupClick = () => {
    setErrorPopup(true);
  };
  const handleHideErrorPopupClick = () => {
    setErrorPopup(false);
  };
  const PostDatedPrescriptionsDetails = (nextPage: number) => {
    let DataOfPayLoad = {
      doctorId: props.docId,
      pageNumber: nextPage,
      pageSize: pageSize,
    };
    dispatch(loadingPostDatedPresDetails(DataOfPayLoad));
  };
  useEffect(() => {
    PostDatedPrescriptionsDetails(page);
  }, [page]);
  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      PostDatedPresDetailsState?.Pagination?.totalItems !== undefined
        ? PostDatedPresDetailsState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [PostDatedPresDetailsState?.Pagination?.totalItems, setRowCountState]);
  return (
    <>
      <Grid item xs={12} md={6}>
        <Box
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            columnGap: 5,
          }}
        >
          {" "}
          <Typography component="span" variant="body2">
            Selected ({selectionData.length})
          </Typography>
          <BtnIconStyle>
            <Tooltip title="Delete">
              <IconButton
                className="trash"
                type="button"
                onClick={handleShowDeletePopupClick}
              >
                <img src={TrashIcon} alt="Delete" loading="lazy" />
              </IconButton>
            </Tooltip>
          </BtnIconStyle>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <AlertWarn>
          <img src={AlertInfoIcon} alt="Alert" loading="lazy" />
          <Typography component="span" variant="body2">
            Post dated controlled substance prescriptions moved to EPCS Queue on
            release date. Please send them to the pharmacy from EPCS Queue.
          </Typography>
        </AlertWarn>
      </Grid>
      <Grid item xs={12}>
        <DataGridListStyle>
          <DataGrid
            rows={PostDatedPresDetailsState?.Items ?? []}
            headerHeight={36}
            sortingOrder={["desc", "asc"]}
            columns={columns2}
            autoHeight
            rowHeight={40}
            checkboxSelection
            pageSize={pageSize}
            disableSelectionOnClick
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            paginationMode="server"
            getRowId={(row) => row.id ?? uuid()}
            loading={PostDatedPresDetailsState.isLoading}
            components={{
              NoRowsOverlay: NoRecords,
              NoResultsOverlay: NoRecords,
              ErrorOverlay: ErrorOverlay,
            }}
            error={PostDatedPresDetailsState?.error || undefined}
            rowCount={rowCountState}
            page={page}
            rowsPerPageOptions={[pageSize]}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            onSelectionModelChange={(ids: any) => {
              setSelectionData(ids);
            }}
          />
        </DataGridListStyle>
      </Grid>
      <Grid item xs={12} my={2}>
        <BtnGroupStyle className="middle">
          <YSButton
            className=""
            children={"Back"}
            variant={"outlined"}
            size={"large"}
            onClick={() => {
              setShowFlow(false);
            }}
          />{" "}
        </BtnGroupStyle>
      </Grid>{" "}
      <DialogPopup
        title="Error Description"
        windowsize={"sm"}
        show={ErrorPopup}
        handleShowPopupClick={handleShowErrorPopupClick}
        handleHidePopupClick={handleHideErrorPopupClick}
      >
        <FailedPopUp rowData={rowData} />
      </DialogPopup>{" "}
      <DialogPopup
        windowsize={"sm"}
        show={deleteDataPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}

const FailedPopUp = (props: any) => {
  const { rowData } = props;
  const {
    errorDescription,
    statusCode,
    description,
    createdDate,
    postDatedPrescriptionDate,
  } = rowData;
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} textAlign="left">
        <Typography component={"div"} variant={"body2"} color="error">
          {errorDescription ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={3}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Status Code
        </Typography>
      </Grid>
      <Grid item xs={12} md={9}>
        <Typography component={"div"} variant={"body2"}>
          {statusCode ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={3}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Drug Description:
        </Typography>
      </Grid>
      <Grid item xs={12} md={9} textAlign="left">
        <Typography component={"div"} variant={"body2"}>
          {description ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={3}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Created On:
        </Typography>
      </Grid>
      <Grid item xs={12} md={9} textAlign="left">
        <Typography component={"div"} variant={"body2"}>
          {createdDate ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={3}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Released On:
        </Typography>
      </Grid>
      <Grid item xs={12} md={9} textAlign="left">
        <Typography component={"div"} variant={"body2"}>
          {postDatedPrescriptionDate ?? "Not Available"}
        </Typography>
      </Grid>
    </Grid>
  );
};
